import { Component, Input, OnInit } from '@angular/core';
import {
  ActiveCartService,
  OrderEntry,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { CartService } from '../../cart/cart.service';

@Component({
  selector: 'app-checkout-order-list',
  templateUrl: './checkout-order-list.component.html',
  styleUrls: ['./checkout-order-list.component.scss'],
})
export class CheckoutOrderListComponent implements OnInit {
  entries: OrderEntry[] | undefined;
  @Input() cartData: any;
  @Input() isOrderConfirmation: Boolean | undefined;
  constructor(
    protected activeCartFacade: ActiveCartService,
    protected translationService: TranslationService,
    protected cartService: CartService,
    protected routingService: RoutingService
  ) {}

  ngOnInit(): void {
    if (this.cartData && this.cartData.entries?.length > 0) {
      this.entries = this.cartData.entries;
    } else {
      this.routingService.go({
        cxRoute: 'cart',
      });
    }
  }
}
